import { ValidationErrors } from '@angular/forms';
import { Option } from '../../settings/model/value-field';

export interface FormFieldElement {
  name: string;
  textName?: string;
  defaultValue?: any;
  pk?: boolean;
  disabledOnEdit?: boolean;
  disabledOnNew?: boolean;
  fieldType: FormFieldType;
  formFieldType?: string;
  min?: number;
  max?: number;
  minLength?: number;
  maxLength?: number;
  step?: number;
  pattern?: string;
  options?: Option[];
  validators?: FormFieldValidator[];
}

export interface FormFieldValidator {
  validator: (param: any) => ValidationErrors | null;
  validatorErrorName: string;
  errorKey: string;
  errorParams?: any;
}

export enum FormFieldType {
  INPUT = 'input',
  SELECT = 'select',
  MULTI_SELECT = 'multi-select',
  MULTI_SELECT_WITH_ALL = 'multi-select-all',
  CHECKBOX = 'checkbox',
  HIDDEN_INPUT = 'hidden',
  AUTOCOMPLETE = 'autocomplete'
}
